import React from 'react';

const ContactButtons = () => {
  return (
    <div 
      className="contact-buttons" 
      style={{
        position: 'fixed', 
        bottom: '20px', 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'flex-end', // 👈 move to right
        padding: '0 20px', 
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      <a 
        href="https://wa.me/919730707888?text=Hello%20Aaryan%20Travels%20Team%2C%0A%0AI%20am%20interested%20in%20booking%20a%20car%20for%20corporate%20travel%20or%20airport%20transfer.%20Could%20you%20please%20share%20the%20available%20vehicle%20options%2C%20pricing%2C%20and%20booking%20details%3F%20Thank%20you%21"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#25D366', 
          borderRadius: '50%', 
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001,
          pointerEvents: 'auto',
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1DAE3E')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#25D366')}
      >
        <img
          src="/images/whatsapp.png"
          alt="WhatsApp"
          style={{ width: '30px', height: '30px' }}
        />
      </a>
    </div>
  );
};

export default ContactButtons;
